import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';
import {StatisticBarStyleModel} from './statistic-bar-style.model';

@Component({
  selector: 'app-statistic-bar',
  templateUrl: './statistic-bar.component.html',
  styleUrls: ['./statistic-bar.component.scss']
})
export class StatisticBarComponent implements OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('barVal') barVal!: ElementRef;
  @ViewChild('barContainer') barContainer!: ElementRef;
  leftPosition = '0px';
  private resizeObserver: ResizeObserver;
  private isDestroyed = false;

  @Input() model: {
    firstVal: number;
    percent: number;
    lastVal: number;
    styleType?: StatisticBarStyleModel;
  } = null;

  constructor(
    private cdRef: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.initResizeObserver();
    this.updateLeftPosition();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      this.updateLeftPosition();
    }
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private initResizeObserver(): void {
    this.resizeObserver = new ResizeObserver(() => {
      this.updateLeftPosition();
    });

    if (this.barContainer.nativeElement) {
      this.resizeObserver.observe(this.barContainer.nativeElement);
    }

    if (this.barVal.nativeElement) {
      this.resizeObserver.observe(this.barVal.nativeElement);
    }
  }

  private updateLeftPosition(): void {
    requestAnimationFrame(() => {
      if (this.isDestroyed) {
        return;
      }
      if (!this.barContainer || !this.barVal || !this.model) {
        return;
      }

      const containerWidth = this.barContainer.nativeElement.offsetWidth;
      const textWidth = this.barVal.nativeElement.offsetWidth;
      const percent = this.model.percent || 0;

      const maxLeftPx = containerWidth - textWidth;
      const leftPx = (percent / 100) * containerWidth;
      const adjustedPx = Math.min(leftPx, maxLeftPx);

      this.leftPosition = `${adjustedPx.toFixed(1)}px`;
      this.cdRef.detectChanges();
    });
  }

  getBackground(percent: number): string {
    return `linear-gradient(to right, var(--warning_bg_3) 0%, var(--warning_bg_2)
     ${percent}%, var(--rgba_main_light_bg_5) ${percent}%, var(--rgba_main_light_bg_5) 100%)`;
  }
}
